import { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { ReactComponent as CloseBlack } from "../../../../assets/img/icon/close_black_24dp.svg";
import { ReactComponent as Ellipsis } from "../../../../assets/img/icon/more_vert_black_24dp.svg";
import { ReactComponent as Search } from "../../../../assets/img/icon/search_black_24dp.svg";
import logoMd from "../../../../assets/img/logo/logomd.png";
import logoSm from "../../../../assets/img/logo/logosm.png";
import { COLOR } from "../../../../config/constant";
import { cleanUpdateTokenJob } from "../../../../services/httpService/loginRequest";
import { GlobalContext } from "../../../contexts/globalContext";

const searchList = [
  { keyword: "Dashboard", path: "/" },
  { keyword: "Pasien", path: "/patient" },
  { keyword: "Rekam medis", path: "/record" },
  { keyword: "Perangkat", path: "/device" },
  { keyword: "Profil", path: "/profile" },
  { keyword: "FAQ", path: "/faq" },
  { keyword: "Tentang aplikasi", path: "/about" },
];

const NavbarDashboard = (props) => {
  const [sharedState, dispatch] = useContext(GlobalContext);
  const [search, setSearch] = useState("");

  const [popUp, setPopUp] = useState(false);
  const history = useHistory();

  const handleKeyPress = async (e) => {
    try {
      if (e.key === "Enter") {
        if (search === "") return;
        let res = searchList.find((obj) => obj.keyword === search);
        if (res === undefined)
          throw new Error("Maaf kami belum memiliki informasi ini.");
        history.push(res.path);
      }
    } catch (error) {
      // console.log(error.message);
      dispatch("alert", {
        show: true,
        message: error.message,
        type: "warning",
      });
    }
  };

  const handleConfirmLogout = () => {
    if (!popUp) return;
    setPopUp(false);
    dispatch("confirm", {
      show: true,
      message: "Anda yakin akan keluar dari aplikasi respinos?",
      callback: () => {
        dispatch("confirm", { show: false });
        dispatch("isLoading", true);
        setTimeout(() => {
          sessionStorage.clear();
          dispatch("user", {
            _id: "",
            token: "",
            isLogin: false,
            email: "",
            name: "",
            profile: "",
            role: "",
          });
          dispatch("isLoading", false);
          history.push("/login");
          cleanUpdateTokenJob();
        }, 500);
      },
    });
  };

  return (
    <nav className="w-full py-2 bg-primary border-b border-white border-opacity-20 fixed  top-0 z-20">
      <div className="px-2 md:px-6 xl:container mx-auto flex justify-between items-center">
        {/* LEFT NAV  */}
        <div className="flex items-center w-full md:w-auto">
          <div className="bg-white py-1  px-1 sm:px-1.5 rounded flex-shrink-0">
            <img src={logoMd} alt="respinos" className="h-8 hidden sm:block" />
            <img src={logoSm} alt="respinos" className="h-7 block sm:hidden" />
          </div>
          <div className="ml-3 sm:ml-5 xl:ml-16 w-full sm:w-112 relative  arrow-hidden overflow-hidden">
            <Search
              fill="#fafafa90"
              className="absolute top-1 -left-10 md:left-2"
            />
            <input
              className="w-full pl-2 md:pl-10 pr-2 md:pr-3 py-1.5 bg-white  bg-opacity-10 text-white text-opacity-90 placeholder-white placeholder-opacity-50 rounded-full focus:outline-none focus:bg-opacity-30"
              placeholder="Cari"
              type="text"
              name="search"
              value={search}
              list={"searcList"}
              onChange={(e) => setSearch(e.target.value)}
              onKeyPress={handleKeyPress}
            />
            <datalist id="searcList">
              {searchList.map((obj) => (
                <option key={"option-" + obj.keyword}>{obj.keyword}</option>
              ))}
            </datalist>
          </div>
        </div>
        {/* RIGHT NAV  */}
        <div className="flex items-center space-x-2 md:space-x-5">
          <div className="block sm:hidden px-1" onClick={props.sidebarToggler}>
            <Ellipsis className="w-5 cursor-pointer fill-current text-white" />
          </div>
          <div className="hidden sm:block relative">
            <div
              className="flex space-x-2 items-center cursor-pointer"
              onClick={() => setPopUp(!popUp)}
            >
              <div
                className="rounded-full bg-white bg-center bg-cover"
                style={{
                  width: "2rem",
                  height: "2rem",
                  backgroundImage: `url("${sharedState.user.profile.avatar}")`,
                }}
              />
              <p className="text-white hidden md:block">
                {sharedState.user.name}
              </p>
            </div>
            <div
              className={
                "absolute right-0 duration-100 ease-in overflow-hidden " +
                (popUp ? "opacity-100 top-10 h-auto  " : "opacity-30 h-0 top-0")
              }
              style={{ zIndex: popUp ? "10" : "-100" }}
            >
              <div className="w-64 bg-secondary shadow-lg text-white rounded-xl px-3 py-3 relative">
                <div
                  className="absolute top-1.5 right-1.5 cursor-pointer"
                  onClick={() => setPopUp(false)}
                >
                  <div className="w-3 h-3 bg-white rounded-full shadow-lg">
                    <CloseBlack
                      fill={COLOR.PRIMARY}
                      className="w-3 h-3 mx-auto"
                    />
                  </div>
                </div>
                <div
                  className="w-16 md:w-24 h-16 md:h-24 border-2 border-white bg-white rounded-full mx-auto bg-center bg-cover "
                  style={{
                    backgroundImage: `url("${sharedState.user.profile.avatar}")`,
                  }}
                ></div>
                <div className="text-center">
                  <div className="mt-2 text-base md:text-lg">
                    {sharedState.user.name}
                  </div>
                  <div className="-mt-1 text-xs md:text-sm text-white text-opacity-60">
                    {sharedState.user.email}
                  </div>
                  <div className="mt-3">
                    <div
                      className={
                        "text-sm bg-primary p-1 rounded " +
                        (popUp ? "cursor-pointer" : "")
                      }
                      onClick={handleConfirmLogout}
                    >
                      Keluar
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};
export default NavbarDashboard;
